import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../constants/Languages.js';

import cookies from '../assets/icons/cookies.svg';
import arrow from '../assets/icons/arrow-circle-empty-light.svg';

const CookieBar = ({ clang, closeCookieBar }) => {
    return (
        <div className="cookie-bar">
            <div className="cookie-bar__content">
                <div className="cookie-bar__content--left">
                    <h5 className="cookie-bar__header">
                        <img src={cookies} alt="" className="cookie-bar__img"/>
                        {lang[clang].cookies_header}
                    </h5>
                    <p className="cookie-bar__desc">{lang[clang].cookies_desc}</p>
                </div>
                <button className="cookie-bar__button" onClick={() => closeCookieBar()}>
                    {lang[clang].accept}
                    <img src={arrow} alt="" className="cookie-bar__button-img"/>
                </button>
            </div>
        </div>
    );
};

CookieBar.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(CookieBar);



// WEBPACK FOOTER //
// ./src/components/CookieBar.js